import {
  getCrawlerVisionLogoPath,
  crawlervisionLogoDimensions,
} from '../config/brand';

function inferTailwindHeightPx(className) {
  if (!className) return undefined;
  let height;
  for (const token of className.split(/\s+/)) {
    const h = token.match(/^h-(\d+(?:\.\d+)?)$/);
    if (h) height = Math.round(parseFloat(h[1], 10) * 4);
    const maxH = token.match(/^max-h-(\d+(?:\.\d+)?)$/);
    if (maxH) {
      const px = Math.round(parseFloat(maxH[1], 10) * 4);
      height = height ? Math.min(height, px) : px;
    }
  }
  return height;
}

/**
 * Official Crawler Vision wordmark — `onLight` = black on light UI;
 * `onDark` = white on navy/teal/dark UI (no CSS filters).
 */
export default function CrawlerVisionLogo({
  className = 'h-10 w-auto object-contain',
  alt = 'Crawler Vision',
  variant = 'onLight',
  intrinsicHeight,
}) {
  const heightPx = intrinsicHeight ?? inferTailwindHeightPx(className);
  const dims = heightPx ? crawlervisionLogoDimensions(heightPx, variant) : null;

  return (
    <img
      src={getCrawlerVisionLogoPath(variant)}
      alt={alt}
      className={className}
      loading="eager"
      decoding="async"
      {...(dims ? { width: dims.width, height: dims.height } : {})}
    />
  );
}
